import React, { useEffect, useState, useRef } from 'react';
import { Mic, MicOff } from 'lucide-react';

/**
 * VoiceInput component wraps the Web Speech API for simple voice-driven search.
 * onResult(text) is called with the final transcript.
 */
const VoiceInput = ({ onResult }) => {
  const [listening, setListening] = useState(false);
  const recognitionRef = useRef(null);

  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) return;
    const recog = new SpeechRecognition();
    recog.continuous = false;
    recog.interimResults = false;
    recog.lang = navigator.language || 'en-US';
    recog.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
      onResult(transcript);
    };
    recog.onend = () => {
      setListening(false);
    };
    recognitionRef.current = recog;
  }, [onResult]);

  const toggleListening = () => {
    const recog = recognitionRef.current;
    if (!recog) return;
    if (listening) {
      recog.stop();
      setListening(false);
    } else {
      try {
        recog.start();
        setListening(true);
      } catch (e) {
        console.warn('VoiceInput start error:', e);
      }
    }
  };

  // Hide if browser doesn't support SpeechRecognition
  if (!recognitionRef.current) return null;

  return (
    <button
      type="button"
      onClick={toggleListening}
      className="ml-2 p-1 text-gray-600 hover:text-gray-800"
      aria-label={listening ? 'Stop voice search' : 'Start voice search'}
    >
      {listening ? <MicOff size={20} className="text-red-500 animate-pulse" /> : <Mic size={20} />}
    </button>
  );
};

export default VoiceInput;